var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeLightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.019px",
    height: "16.018px",
    viewBox: "79.017 120.074 16.019 16.018",
    enableBackground: "new 79.017 120.074 16.019 16.018",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0fb85d",
    d: "M87.027,120.074c-4.417,0-8.01,3.593-8.01,8.009s3.593,8.009,8.01,8.009c4.415,0,8.009-3.593,8.009-8.009 S91.442,120.074,87.027,120.074z M87.027,135.101c-3.87,0-7.019-3.148-7.019-7.019s3.148-7.019,7.019-7.019 s7.018,3.148,7.018,7.019S90.897,135.101,87.027,135.101z M87.768,122.055h-0.99v6.936h4.954V128h-3.964V122.055z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeLightGreen);
export default __webpack_public_path__ + "static/media/icon_time-light-green.354a5028b8cf13a18c11640eb4e38aed.svg";
export { ForwardRef as ReactComponent };